// Subscriptions the backend refuses to enable agentToolKit for (CanEnableAISubscriptionFlag in
// pendo-appengine model/subscription.go): every non-paid tier — Pendo Free, Starter, Starter
// 2024, any trial — and either AI-processing opt-out. The side nav hides the toolkit for them
// and the splash disables adding, so nobody walks into the wizard's 403.
export function isAgentToolkitBlocked ({
    getFeatureFlag = () => false,
    isPendoFree = false,
    isInTrial = false,
    isStarterPackage = false,
    isStarter2024Package = false,
} = {}) {
    return Boolean(isPendoFree || isInTrial || isStarterPackage || isStarter2024Package)
        || isAgentToolkitAiOptedOut(getFeatureFlag);
}

// the AI-processing opt-outs the backend maps to agentToolKit's model sources (Google, Pendo)
export function isAgentToolkitAiOptedOut (getFeatureFlag = () => false) {
    return Boolean(getFeatureFlag('doNotProcessGoogleGenAi')) || Boolean(getFeatureFlag('doNotProcessPendoAi'));
}

export const ATK_SUB_FLAG = 'agentToolKit';

// The agent routes' guard and the admin-only configs API both need the toolkit flag and its
// service-account prerequisite, so the landing and wizard read the same pair: agentToolKit
// alone would call an API that 403s instead of showing the splash.
export const ATK_ACCESS_FLAGS = Object.freeze([ATK_SUB_FLAG, 'allowIntegrationKey']);

export function hasAgentToolkitAccess (getFeatureFlag = () => false) {
    return ATK_ACCESS_FLAGS.every((flag) => Boolean(getFeatureFlag(flag)));
}

// Pre-launch discoverability (side-nav item, Go-to-page link): only where the toolkit is already
// on or the viewer is in the enableAtkCustomAgent segment, and never on a blocked subscription.
// The landing itself stays reachable by URL.
export function isAgentToolkitDiscoverable ({ hasSegmentFlag = () => false, ...subscription } = {}) {
    if (isAgentToolkitBlocked(subscription)) {
        return false;
    }
    const { getFeatureFlag = () => false } = subscription;

    return Boolean(getFeatureFlag(ATK_SUB_FLAG)) || Boolean(hasSegmentFlag('enableAtkCustomAgent'));
}
